var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApproved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 8.49594L15.1145 6.23794L15.3773 3.24892L12.5877 2.5829L11.1273 0L8.5 1.18586L5.87273 0L4.41227 2.5829L1.62273 3.2408L1.88545 6.22981L0 8.49594L1.88545 10.7539L1.62273 13.7511L4.41227 14.4171L5.87273 17L8.5 15.806L11.1273 16.9919L12.5877 14.409L15.3773 13.743L15.1145 10.7539L17 8.49594ZM6.95455 12.5571L3.86364 9.30817L4.95318 8.16292L6.95455 10.2585L12.0468 4.90588L13.1364 6.05925L6.95455 12.5571Z",
    fill: "#0094FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproved);
export default __webpack_public_path__ + "static/media/approved.e38ba262cfc09180aa773c6cb7df74fc.svg";
export { ForwardRef as ReactComponent };